module.exports = __webpack_public_path__ + "static/img/release-link.150ced5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release-link.png
// module id = 9Ad5
// module chunks = 36